import React, { useState } from 'react';
import { MenuItem } from './MenuItem/MenuItem';
import './navbar.scss';

export const Navbar = (props) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const handleSelectItem = () => {
    setMenuOpened(!menuOpened);
  };

  return (
    <>
      <nav className="navbar_mobile">
        <button
          className={menuOpened ? 'hamburger hamburger--opened' : 'hamburger'}
          aria-label="menu"
          onClick={() => {
            setMenuOpened(!menuOpened);
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        {menuOpened && (
          <ul className="menuItems">
            <MenuItem
              link="#whatWeDo"
              itemName="Co děláme"
              onSelect={handleSelectItem}
            />
            <MenuItem
              link="#partners"
              itemName="Naši partneři"
              onSelect={handleSelectItem}
            />
            <MenuItem
              link="#contact"
              itemName="Kontakt"
              onSelect={handleSelectItem}
            />
          </ul>
        )}
      </nav>
      <nav className="navbar_desktop">
        <ul className="menuItems menuItems_desktop">
          {props.showLPLinks && (
            <>
              <MenuItem
                link="#whatWeDo"
                itemName="Co děláme"
                onSelect={handleSelectItem}
              />
              <MenuItem
                link="#partners"
                itemName="Naši partneři"
                onSelect={handleSelectItem}
              />
              <MenuItem
                link="#contact"
                itemName="Kontakt"
                onSelect={handleSelectItem}
              />
            </>
          )}
        </ul>
      </nav>
    </>
  );
};
